import { Drawer as AntdDrawer } from "antd";
import styled from "styled-components";

export const DrawerSauces = styled(AntdDrawer)`
  .ant-drawer-body {
    padding: 12px;
  }
`;
